import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../../api';
import '../../styles/AuthModal.css'; // Reusing some styles from AuthModal

const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            setError('Token de redefinição de senha não encontrado.');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        if (password !== confirmPassword) {
            setError('As senhas não coincidem.');
            setLoading(false);
            return;
        }

        if (password.length < 6) {
            setError('A senha deve ter no mínimo 6 caracteres.');
            setLoading(false);
            return;
        }

        try {
            const response = await authAPI.resetPassword({ token, newPassword: password });
            setMessage(response.message);
            setTimeout(() => {
                navigate('/'); // Redirect to home or login page
            }, 3000);
        } catch (err) {
            console.error('Erro ao redefinir senha:', err);
            setError(err.message || 'Ocorreu um erro ao redefinir sua senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-modal-overlay" style={{ position: 'relative', height: '100vh' }}>
            <div className="auth-modal" style={{ top: '50%', transform: 'translate(-50%, -50%)' }}>
                <div className="auth-header">
                    <h2>Redefinir Senha</h2>
                </div>

                {message && <div className="auth-success">{message}</div>}
                {error && <div className="auth-error">{error}</div>}

                {!message && !error && (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <p>Por favor, insira sua nova senha.</p>
                        <div className="form-group">
                            <label htmlFor="password">Nova Senha</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Mínimo 6 caracteres"
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirmar Nova Senha</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Repita sua nova senha"
                                disabled={loading}
                                required
                            />
                        </div>

                        <button type="submit" className="auth-submit" disabled={loading}>
                            {loading ? 'Redefinindo...' : 'Redefinir Senha'}
                        </button>
                    </form>
                )}

                <div className="auth-footer">
                    <p>
                        <Link to="/" className="toggle-link">Voltar para o Login</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
